export const mountableSteps = {
	title: "Produto montável",
	description:
		"Os produtos montáveis permitem que o cliente final faça uma combinação a partir de uma base fixa e uma variedade de ingredientes adicionais. No caso do açaí, por exemplo, a base seria o açaí batido e os ingredientes adicionais seriam paçoca, leite ninho e etc.",
	stepLabel: "Etapa",
	addStep: "Etapa",
	removeStep: "Remover etapa",
	fields: {
		title: {
			label: "Título",
			placeholder: "Digite o título da etapa",
		},
		pricing: {
			label: "Precificação",
			placeholder: "Escolha um método",
			options: {
				sum: {
					label: "Adicional",
					tooltip: "Todo item adicionado será incrementado no valor do produto",
				},
				average: {
					label: "Média",
					tooltip: "A média dos itens selecionados será incrementada",
				},
				higher: {
					label: "Maior valor",
					tooltip: "O maior valor entre os itens será adicionado ao valor do produto",
				},
			},
		},
		min: {
			label: "Valor mínimo",
			tooltip: "Mínimo de itens a ser selecionado",
		},
		max: {
			label: "Valor máximo",
			tooltip: "Máximo de itens a ser selecionado",
		},
	},
	itemsSection: {
		title: "INGREDIENTES ADICIONAIS",
		addItem: "Adicionar outro item",
		removeItem: "Remover item",
		fields: {
			item: {
				label: "Item",
				placeholder: "Selecione um item",
				loadingPlaceholder: "Carregando produtos...",
			},
			price: {
				label: "Valor",
			},
			maxCount: {
				label: "Quantidade máxima selecionável",
				placeholder: "Digite a quantidade",
				tooltip: "Quantidade máxima de vezes que este item pode ser selecionado na seção",
			},
			storageCount: {
				label: "Quantidade abatida",
				placeholder: "0",
				tooltip: "Quantidade que será abatida do estoque por unidade",
			},
			isModification: {
				label: "Item de alteração",
			},
		},
	},
};
